<mapfre-loading *ngIf="loaderLine"></mapfre-loading>

<app-system-maintenance
  *ngIf="showMessage"
  (closeModal)="closeModal()"
></app-system-maintenance>

<app-profile-confirm-modal
  [toDo]="'removeAccount'"
  [selectedPolicyId]="policyId"
  [bankAccount]="bankAccountNumber"
  *ngIf="confirmModal"
></app-profile-confirm-modal>
<ng-container *ngIf="!loaderLine">
  <div>
    <div class="row text-center">
      <div class="col">
        <div class="header-icon mb-2" [ngClass]="{ 'mb-3': isAcmic }">
          <figure class="no-margin-bottom">
            <img src="./assets/img/images/profile.svg" alt="My Account" />
          </figure>
        </div>
        <h1 class="title-copy mb-4">{{ 'PROFILE_MAIN_ONE' | translate }}</h1>
      </div>
    </div>
    <div class="mt-3">
      <div
        class="profile-row cursor-pointer"
        [routerLink]="['/profile', 'enter-password']"
      >
        <label
          class="profile account-settings dm-sans-medium no-margin-bottom cursor-pointer"
          >{{ 'PROFILE_MAIN_TWO' | translate }}</label
        >
        <ng-container *ngIf="!isAcmic; else acmicEditPassword">
          <img
            src="assets/img/images/icon-simple-arrow-right-red.svg"
            alt="right arrow icon"
          />
        </ng-container>
        <ng-template #acmicEditPassword>
          <img
            src="assets/img/images/icon-simple-arrow-right-blue.svg"
            alt="right arrow icon"
          />
        </ng-template>
      </div>
      <hr class="hr-profile" />
      <div
        class="profile-row cursor-pointer"
        [routerLink]="['/profile', 'manage-contact-details']"
      >
        <div class="option-block">
          <label
            class="profile account-settings dm-sans-medium no-margin-bottom cursor-pointer"
            >{{ 'Contact details' | translate }}</label
          >
          <ng-container *ngIf="displayContactText; else policyMustActive">
            <div class="add-info mt-2">
              <ng-container
                *ngIf="
                  isAS400PolicyForDisplayText ||
                    showCompany === 'tw' ||
                    showCompany === 'acic' ||
                    !existMaPolicy;
                  else gwPolicy
                "
              >
                {{ 'Update your email address' | translate }}
              </ng-container>
              <ng-template #gwPolicy>
                {{ 'Update your email address and phone numbers.' | translate }}
              </ng-template>
            </div>
          </ng-container>
          <ng-template #policyMustActive>
            <div class="add-info mt-2">
              {{
                'Your policy must be active and linked to your online account to update your contact information'
                  | translate
              }}
            </div>
          </ng-template>
        </div>

        <div class="text-right" *ngIf="displayContactText">
          <ng-container *ngIf="!isAcmic; else acmicEditContact">
            <img
              src="assets/img/images/icon-simple-arrow-right-red.svg"
              alt="right arrow icon"
            />
          </ng-container>
          <ng-template #acmicEditContact>
            <img
              src="assets/img/images/icon-simple-arrow-right-blue.svg"
              alt="right arrow icon"
            />
          </ng-template>
        </div>
      </div>

      <hr class="hr-profile" />
      <div
        class="profile-row cursor-pointer"
        [routerLink]="['/profile', 'two-factor-authentication']"
      >
        <div class="option-block">
          <label
            class="profile account-settings dm-sans-medium no-margin-bottom cursor-pointer"
          >
            {{ 'Two-factor authentication' | translate }}
          </label>
          <div class="add-info mt-2">
            {{ 'Review or edit your authentication methods.' | translate }}
          </div>
        </div>

        <div class="text-right">
          <ng-container *ngIf="!isAcmic; else acmicEditContact">
            <img
              src="assets/img/images/icon-simple-arrow-right-red.svg"
              alt="right arrow icon"
            />
          </ng-container>
          <ng-template #acmicEditContact>
            <img
              src="assets/img/images/icon-simple-arrow-right-blue.svg"
              alt="right arrow icon"
            />
          </ng-template>
        </div>
      </div>

      <ng-container *ngIf="useBiometrics">
        <hr class="hr-profile" />
        <div class="row">
          <label class="profile account-settings no-margin-bottom col">{{
            'Use Biometrics' | translate
          }}</label>
          <a class="col-auto text-right margin-right mr32">
            <label class="mapfre switch-container inline-bio">
              <div class="switch fat">
                <input
                  type="checkbox"
                  (change)="saveBiometrics($event)"
                  [checked]="bioStored"
                />
                <span class="slider round"></span>
              </div>
            </label>
          </a>
        </div>
      </ng-container>
      <ng-container *ngIf="paperlessNotAvailable">
        <hr class="hr-profile" />
      <div class="d-flex-mob-colm">
        <label
          class="profile account-settings dm-sans-medium no-margin-bottom margin-top"
        >
          {{ 'PAPERLESS_SETTINGS' | translate }}
        </label>
        <div class="paperless-option">
          {{ 'OPTION_NOT_AVAILABLE' | translate }}
        </div>
      </div>
      </ng-container>

      <ng-container *ngIf="existMaPolicy && !paperlessNotAvailable">
        <hr class="hr-profile" />
        <div
          class="heading-paperSetting cursor-pointer"
          [routerLink]="isPaperless ? null : ['/billing', 'paperless']"
          (click)="isPaperless && onShowMessage()"
        >
          <label
            class="profile account-settings dm-sans-medium no-margin-bottom margin-top cursor-pointer"
          >
            {{ 'PAPERLESS_SETTINGS' | translate }}
          </label>
          <div class="link-editBtn">
            <ng-container *ngIf="!isAcmic; else acmicpaperlessSetttings">
              <img
                src="assets/img/images/icon-simple-arrow-right-red.svg"
                alt="right arrow icon"
              />
            </ng-container>
            <ng-template #acmicpaperlessSetttings>
              <img
                src="assets/img/images/icon-simple-arrow-right-blue.svg"
                alt="right arrow icon"
              />
            </ng-template>
          </div>
        </div>
      </ng-container>
      <hr class="hr-profile" />
      <div class="d-flex-mob-colm" *ngIf="!eftEligibleFlag">
        <label
          class="profile account-settings dm-sans-medium no-margin-bottom margin-top"
        >
          {{ 'AUTO_PAY_SETTINGS' | translate }}
        </label>
        <div class="paperless-option">
          {{ 'OPTION_NOT_AVAILABLE' | translate }}
        </div>
      </div>
      <div
        *ngIf="eftEligibleFlag"
        class="heading-paperSetting cursor-pointer"
        [routerLink]="isAutoPay ? null : ['/billing', 'autopay']"
        (click)="isAutoPay && onShowMessage()"
      >
        <label
          class="profile account-settings dm-sans-medium no-margin-bottom margin-top cursor-pointer"
        >
          {{ 'AUTO_PAY_SETTINGS' | translate }}
        </label>
        <div class="link-editBtn">
          <ng-container *ngIf="!isAcmic; else acmicIsAutoPay">
            <img
              src="assets/img/images/icon-simple-arrow-right-red.svg"
              alt="right arrow icon"
            />
          </ng-container>
          <ng-template #acmicIsAutoPay>
            <img
              src="assets/img/images/icon-simple-arrow-right-blue.svg"
              alt="right arrow icon"
            />
          </ng-template>
        </div>
      </div>

      <ng-container *ngIf="acmicAllonEFT || maAllonEFT">
        <hr class="hr-profile" />
        <div class="manage-paymentMethod margin-bottom mb16">
          <div class="option-block">
            <label
              class="profile account-settings dm-sans-medium no-margin-bottom margin-right mr16"
            >
              {{ 'PROFILE_MAIN_FOUR' | translate }}
            </label>
            <div
              class="add-info mt-2"
              *ngIf="!isAcmic && showCompany === 'all'"
            >
              {{
                'Only available for Massachusetts personal policies' | translate
              }}
            </div>
            <div class="add-info mt-2">
              {{ 'PROFILE_MAIN_EIGHT' | translate }}
            </div>
          </div>

          <div *ngIf="PolicyArray && policyFlag">
            <div
              *ngFor="let policy of PolicyArray | sortByStatus : '-effDate'"
              [hidden]="policy?.days_left_to_expire < 0"
            >
              <ng-container
                *ngIf="
                  !policy?.isNewPolicy &&
                  policy?.policyFlags?.isEft !== 'ENROLLED' &&
                  ((policy?.policynumber?.policyNumber.length === 10 &&
                    !isAcmic) ||
                    isAcmic)
                "
              >
                <div class="manage-bank-account-sec">
                  <div class="policy-bank-block">
                    <div class="policy-info">
                      {{ policy?.displayType?.label | translate }} &ndash;
                      {{ policy?.policynumber.policyNumber }}
                    </div>
                    <div
                      class="bank-info"
                      *ngIf="
                        !policy?.hasAffinityGroup &&
                        policy?.bankStatus &&
                        policy?.bankInfo?.accountNumber?.digits
                      "
                    >
                      {{ 'PROFILE_MAIN_SIX' | translate }}
                      {{ policy?.bankInfo?.accountNumber?.digits.slice(-4) }}
                    </div>
                  </div>

                  <div
                    class="col-main-add-info"
                    *ngIf="policy?.hasAffinityGroup"
                  >
                    <span class="main-add-info">
                      {{ 'POLICY_BILL_AFFINITY_GROUP' | translate }}
                    </span>
                  </div>

                  <div class="d-flex" *ngIf="!policy?.hasAffinityGroup">
                    <ng-container *ngIf="isACH">
                      <a
                        *ngIf="!policy?.bankStatus; else editBank"
                        (click)="onShowMessage()"
                        [routerLink]
                        class="btn-manage-bank-action"
                      >
                        {{ 'Add' | translate }}
                      </a>
                      <ng-template #editBank>
                        <a
                          (click)="onShowMessage()"
                          [routerLink]
                          class="btn-manage-bank-action"
                        >
                          {{ 'Edit' | translate }}
                        </a>
                        <a
                          class="btn-manage-bank-action ml-3"
                          [routerLink]
                          (click)="onShowMessage()"
                        >
                          {{ 'Remove' | translate }}
                        </a>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngIf="!isACH">
                      <a
                        *ngIf="!policy?.bankStatus; else editBank"
                        [routerLink]="[
                          '/profile/' +
                            policy?.policynumber.policyNumber +
                            '/add-checking-account/'
                        ]"
                        class="btn-manage-bank-action"
                      >
                        {{ 'Add' | translate }}
                      </a>
                      <ng-template #editBank>
                        <a
                          [routerLink]="[
                            '/profile/' +
                              policy?.policynumber.policyNumber +
                              '/edit-checking-account/'
                          ]"
                          class="btn-manage-bank-action"
                        >
                          {{ 'EDIT' | translate }}
                        </a>
                        <a
                          class="btn-manage-bank-action ml-3"
                          (click)="
                            onRemoveAccount(
                              policy?.policynumber.policyNumber,
                              policy?.bankInfo?.accountNumber?.digits
                            )
                          "
                        >
                          {{ 'Remove' | translate }}
                        </a>
                      </ng-template>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="livoPolicy && !allAffinityGroup">
        <hr class="hr-profile" />
        <div class="d-flex-mob-colm">
          <div class="option-block">
            <label
              class="profile account-settings dm-sans-medium no-margin-bottom margin-right mr16"
            >
              {{ 'PROFILE_MAIN_SEVEN' | translate }}
            </label>
            <div
              class="add-info mt-2"
              *ngIf="!isAcmic && showCompany === 'all'"
            >
              {{
                'Only available for Massachusetts personal policies' | translate
              }}
            </div>
            <div class="add-info mt-2">
              {{ 'PROFILE_CARDS' | translate }}
            </div>
          </div>

          <ng-container *ngIf="isPaymentus">
            <div class="w-100-mobile">
              <a
                class="wallet-profile-button w-100-mobile"
                (click)="onShowMessage()"
                [routerLink]
              >
                {{ 'MANAGE' | translate }}
              </a>
            </div>
          </ng-container>
          <ng-container *ngIf="!isPaymentus">
            <div class="w-100-mobile">
              <a
                class="wallet-profile-button w-100-mobile"
                [routerLink]="['wallet-details']"
              >
                {{ 'MANAGE' | translate }}
              </a>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
